import {ModalComponentProps, Card, Block, Dialog, Col, Row, DialogBody, DialogFooter, Button, LabelValueList, LabelValue} from '@mc/ui-v4';

import {WaitForQueryData} from '@mc/react-app-v4';
import React from 'react';
import {useAppConfig} from '@mc/react-app-base';
import {useQuery} from 'react-query';
import {ParovaniApi, QrVO} from '../../api';

type Props = ModalComponentProps;

export const ModalQR: React.FC<Props> = ({onClose}) => {
    const mapioParovaniQuery = useQuery<QrVO>(['CACHE_KEY_QR_DATA'], async () => (await ParovaniApi.getQr()).data);

    const app = useAppConfig();
    return (
        <Dialog size={'md'} onClose={onClose} title={'Párování mobilní aplikace'}>
            <DialogBody>
                <Card mode={'edit'}>
                    <Block>
                        <Row>
                            <Col>
                                <img src={`${window.origin}${app.serverContextPath}/api/parovani/qr`} alt={'chyba v získání QR'} />
                            </Col>
                            <Col>
                                <WaitForQueryData queries={[mapioParovaniQuery]}>
                                    {() => {
                                        const data = mapioParovaniQuery.data;
                                        return (
                                            <LabelValueList emptyValue={'-'}>
                                                <LabelValue horizontal label={'URL'}>
                                                    {data.url}
                                                </LabelValue>
                                                <LabelValue horizontal label={'Popis'}>
                                                    {data.popis}
                                                </LabelValue>
                                                <LabelValue horizontal label={'Kod aplikace'}>
                                                    {data.kodAplikace}
                                                </LabelValue>
                                            </LabelValueList>
                                        );
                                    }}
                                </WaitForQueryData>
                            </Col>
                        </Row>
                    </Block>
                </Card>
            </DialogBody>
            <DialogFooter>
                <Button style={'link'} onClick={onClose}>
                    Zavřít
                </Button>
            </DialogFooter>
        </Dialog>
    );
};
